
import { format, parseISO } from "date-fns";

interface DateTimeDisplayProps {
  label: string;
  dateString: string;
}

export const DateTimeDisplay = ({ label, dateString }: DateTimeDisplayProps) => {
  const formatDateTime = (dateString: string) => {
    try {
      // Parse the ISO string exactly as is without timezone adjustments
      const date = parseISO(dateString);
      
      // Format the date using 24-hour format to match backend time display
      // This preserves the exact time as stored in the database
      return format(date, "dd MMM yyyy, HH:mm");
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };

  return (
    <p className="text-sm">
      {label}: {formatDateTime(dateString)}
    </p>
  );
};
